<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.customerPortfolioModuleEdit.title' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.customerPortfolioModuleEdit.noResponseTimeoutLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="noResponseTimeoutCustomerPortfolio" [placeholder]="'shared.customerPortfolioModuleEdit.categoryPlaceholder' | translate" />
          <field-error-component [field]="'noResponseTimeoutCustomerPortfolio'" [label]="'noResponseTimeoutCustomerPortfolio'" [formGroup]="formGroup" />
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'shared.customerPortfolioModuleEdit.cancelButton' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ isNew ? ('shared.customerPortfolioModuleEdit.saveButton' | translate) : ('shared.customerPortfolioModuleEdit.editButton' | translate) }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>
    
  </div>
</div>
